const listadoEmpresas = {
  carousel: {
    title: 'Empresas populares',
  },
}

export default listadoEmpresas
